import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TooltipModule} from 'ng2-bootstrap/tooltip';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {ConstructListModule} from './construct-list/construct-list.module';
import {DialogDatepickerModule} from './dialog-datepicker/dialog-datepicker.module';
import {DialogsDetailsRoutingModule} from './dialogs-details-routing.module';
import {DialogsDetailsComponent} from './dialogs-details.component';
import {DialogsDetailsRepository} from './repositories/dialogs-details.repository';
import {DialogsDetailsService} from './services/dialogs-details.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogsDetailsRoutingModule,
    ConstructListModule,
    LanguageDropdownModule,
    DialogDatepickerModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    DialogsDetailsComponent,
  ],
  providers: [
    DialogsDetailsService,
    DialogsDetailsRepository,
  ],
})
export class DialogsDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/dialogs-details.module.ts